import html2canvas from "html2canvas";
import jsPDF from "jspdf";

// Captures the rendered invoice DOM and returns a PDF (US Letter).
// Uses the EXACT same component the preview renders, so output is identical.
export async function downloadInvoicePDF(node, fileName = "invoice.pdf") {
  if (!node) throw new Error("Invoice node not available");

  const canvas = await html2canvas(node, {
    scale: 2,
    backgroundColor: "#ffffff",
    useCORS: true,
    logging: false,
    windowWidth: node.scrollWidth,
    windowHeight: node.scrollHeight,
  });

  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF({ unit: "pt", format: "letter", orientation: "portrait" });

  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const ratio = canvas.width / canvas.height;

  // Fit by width; if taller than one page, scale down to fit page height.
  let w = pageW;
  let h = w / ratio;
  if (h > pageH) {
    h = pageH;
    w = h * ratio;
  }
  const x = (pageW - w) / 2;
  pdf.addImage(imgData, "PNG", x, 0, w, h);
  pdf.save(fileName);
}

export function printInvoice() {
  window.print();
}
